import React, { useState, useEffect } from 'react';
import News from '../../JsonFiles/News.json';
import NewsRoomList from '../../components/NewsRoomList/NewsRoomList';
import IntroTemplate from '../../components/IntroTemplate/IntroTemplate';
import axios from 'axios';
import { getStoredData } from '../../JsonFiles/fetchData';
import HomeBlog from '../../components/HomeBlog/HomeBlog';


const NewsRoom = () => {
  const data = getStoredData()?.["10"] ?? {};
  const [blog, setBlog] = useState([]);
  const [News, setNews] = useState([]);

  useEffect(() => {
    // Fetch blog
    axios.get('https://shahbad-enterprises-backend.vercel.app/blog')
      .then(response => setBlog(response.data))
      .catch(error => console.error('Error fetching blog:', error));

      axios.get('https://shahbad-enterprises-backend.vercel.app/news')
      .then(response => setNews(response.data))
      .catch(error => console.error('Error fetching blog:', error));
  }, []);
  
  return (
    <div>
      <IntroTemplate logo={data.logo} title={data.title} image={data.image} />
      <NewsRoomList data={News}/>
      <HomeBlog
        title={data.HomeBlogTitle}
        link={data.HomeBlogLink}
        text={data.HomeBlogText}
        blogs={blog}
      />
    </div>
    
  )
}
export default NewsRoom